import styled from 'astroturf/react';
import Button from 'src/components/Button';

const RestoreButton = styled(Button)`
  font-size: var(--ph-text-sm);
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal !important;
  margin-left: auto !important;
  border: 0 !important;
`;

export default {
  RestoreButton,
};
